import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ArrowRight, ShieldCheck } from 'lucide-react';

const ReturnsPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-20 px-6 max-w-3xl mx-auto text-left font-sans text-[#2C1E12]">
      <button 
        onClick={() => navigate(-1)} 
        className="flex items-center gap-1.5 text-[8px] uppercase tracking-widest text-[#664229] hover:text-[#2C1E12] transition font-black mb-8 bg-transparent border-none cursor-pointer"
      >
        <ArrowLeft size={10} /> Back
      </button>

      <h2 className="text-3xl font-serif uppercase tracking-wider mb-2">Returns & Exchanges Policy</h2>
      <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-8 border-b border-[#2C1E12]/10 pb-4">
        3-Day Premium Protection Framework Clauses
      </p>
      
      <div className="space-y-6 text-xs leading-relaxed font-serif text-zinc-700">
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">
            1. 3-Day Framework Limitation
          </h4>
          <p>
            Modische Kledings enforces a strict **3-day policy window**. Return requests or pattern size exchange requests must be filed directly within **3 days (72 hours)** of your delivery timestamp logs through your account profile order history panel.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">
            2. Eligible Return Conditions
          </h4>
          <p>
            We accept returns and exchanges for any style preference choice, size mismatch, item quality preference variation, or change of mind scenario. The product must remain unwashed, completely unworn, with all original protective luxury layers and designer product tags intact.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2 text-red-950">
            3. Unboxing Video Verification Requirement
          </h4>
          <p className="font-bold text-zinc-800">
            For assertions involving damaged items, incorrect product sizes sent by company error, or missing quantities inside your shipping package, customers are strictly required to provide a continuous, unedited unboxing opening video. Up to 6 verification photo assets must be attached inside the user portal request desk.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">
            4. Settlement Turnaround
          </h4>
          <p>
            Approved return claims are settled via store platform ledger credit values or sent back into your original automated online bank payment option channel within 7 to 10 working financial business days. Original shipping dispatch fees are non-refundable.
          </p>
        </div>
      </div>

      {/* ACTION REDIRECT CALLOUT */}
      <div className="mt-12 p-6 bg-white border border-[#E5D3B3]/60 rounded-xs flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-sm">
        <div className="flex items-center gap-3">
          <ShieldCheck size={24} className="text-[#2C1E12] flex-shrink-0" />
          <div>
            <h5 className="text-xs font-sans font-black uppercase tracking-wider text-[#2C1E12]">Need to file a return or exchange?</h5>
            <p className="text-[10px] font-mono text-zinc-400 mt-0.5">Manage eligible shipments directly from your order dashboard.</p>
          </div>
        </div>
        <button
          onClick={() => navigate('/my-orders')}
          className="px-5 py-2.5 bg-[#2C1E12] text-[#F5F5DC] text-[9px] uppercase tracking-widest font-black rounded-xs border-none cursor-pointer hover:opacity-90 transition flex items-center gap-1.5 flex-shrink-0"
        >
          Go to My Orders <ArrowRight size={10} />
        </button>
      </div>
    </div>
  );
};

export default ReturnsPolicyPage;